import React from "react";
import PATHS from "config/paths";

/* eslint-disable react-hooks/exhaustive-deps */

const cache = new Map();

export function useDeleteSurvivor(token, victim_id, shouldDelete = false) {
  const [error, setError] = React.useState();
  const [isDeleteSurvivorComplete, setIsDeleteSurvivorComplete] = React.useState(false);

  React.useEffect(() => {
    if (token && victim_id && shouldDelete) {        
        setError(undefined);

        const headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", `Bearer ${token}`);
        headers.append("Origin", "{location.protocol + '//' + location.host}");
        const options = {
          method: "DELETE",
          headers: headers,
          redirect: "follow",
          cache: "no-cache",
        };

        /**
         * Make request
         */
        fetch(`${PATHS.apiSurvivors}/${victim_id}/archive`, options)
          .then((response) => {
            setIsDeleteSurvivorComplete(true);
            return response.json();
          })
          .catch((error) => setError(error))
          
        }
    
  }, [token, victim_id, shouldDelete]);

  return { isDeleteSurvivorComplete, deleteSurvivorError: error  };
}
